import { useEffect, useState } from "react";
import { getPublicConfig, type PublicConfig } from "./api";

export function usePublicConfig() {
  const [config, setConfig] = useState<PublicConfig | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    void getPublicConfig()
      .then((value) => {
        if (active) setConfig(value);
      })
      .catch(() => {
        if (active) setError("Không thể tải cấu hình xác thực.");
      });
    return () => {
      active = false;
    };
  }, []);

  return { config, error };
}
